/** Mirrors backend/src/utils/courts/courtType.ts. */
export const COURT_TYPES = ['jp', 'municipal', 'county', 'district', 'other'] as const;
export type CourtType = (typeof COURT_TYPES)[number];

export const COURT_TYPE_LABELS: Record<CourtType, string> = {
  jp: 'Justice of the Peace (JP)',
  municipal: 'Municipal',
  county: 'County / County Court at Law',
  district: 'District',
  other: 'Other',
};

export function courtTypeLabel(value: string | null | undefined): string {
  return value && value in COURT_TYPE_LABELS ? COURT_TYPE_LABELS[value as CourtType] : 'Not set';
}
